import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  _error: any

  get error(): any {
    if(this._error){
      const err = this._error;
      this._error = null;
      return err;
    }
    return null;
  }

  set error(error: any) {
    this._error = error;
  }
}
